

  export default {
    data() {
      return {
        form : {
                  id : '',
                  judul : '',
                  keterangan : '',
                  file : null,
                  file_old : null,
                  userId : '',
                  createAt : '',
                  editedAt : '',
              },
       
        list_data : [],
        list_kategori : [],
        file_path: this.$store.state.url.URL_APP + "uploads/",
  
        page_first: 1,
        page_last: 0,
        cari_value: "",
        cek_load_data : true,
  
        currentDate : '',
        currentDateWithFormat : '',
  
  
        mdl_add: false,
        mdl_open: false,
        mdl_edit: false,
        mdl_hapus : false,
        btn_add: false,
      }
    },
    methods: {
  
  
      getView : function(){
        this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_Dokumen + "view", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
              userId : this.userId,
                data_ke: this.page_first,
                cari_value: this.cari_value
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_data = res_data.data;
                this.page_last = res_data.jml_data;
                this.$store.commit("hideLoading");
        });
      },
  
      addData : function() {
        var formData = new FormData();
        formData.append('data', JSON.stringify(this.form))
        // formData.append('data', JSON.stringify(this.form))
        formData.append('file', this.form.file)
  
        // console.log(formData);
  
        fetch(this.$store.state.url.URL_Dokumen + "addData", {
            method: "POST",
            headers: {
              // "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            console.log(res_data);
            this.getView();
        });
      },
  
  
      editData : function(){
        var formData = new FormData();
        formData.append('data', JSON.stringify(this.form))
        formData.append('file', this.form.file)
        fetch(this.$store.state.url.URL_Dokumen + "editData", {
            method: "POST",
            headers: {
              // "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
            this.getView();
        });
      },
  
      removeData : function(a, b){
        // console.log(a);
        // console.log(b);
        fetch(this.$store.state.url.URL_Dokumen + "removeData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({id : a, file : b})
        }).then(res_data => {
            this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
            this.getView();
        });
  
      },
      selectData : function(data){
          this.form.id = data.id
          this.form.judul = data.judul
          this.form.keterangan = data.keterangan
          this.form.file = this.form.file
          this.form.file_old = data.file
          this.form.createBy = data.createBy
          this.form.createAt = data.createAt

      },
  
      // ====================================== PAGINATE ====================================
          Notify : function(message, positive, icon){
            this.$q.notify({
              message: message,
              color: positive,
              icon: icon,
              position : 'top',
              timeout: 500,
            })
          },
          btn_prev : function(){
              this.cek_load_data = true;
              if(this.page_first>1){
                  this.page_first--
              }else{
                  this.page_first = 1;
              }
              this.getView();
          },
  
          btn_next : function(){
              if(this.page_first >= this.page_last){
                  this.page_first == this.page_last
              }else{
                  this.page_first++;
              }
              this.getView();
          },
  
          cari_data : function(){
              this.page_first = 1;
              this.getView();
          },
  
          date: function () {
  
              var currentDate = new Date();
              console.log(currentDate);
  
              var currentDateWithFormat = new Date().toJSON().slice(0,10).replace(/-/g,'/');
              console.log(currentDateWithFormat);
  
          },
  
          convert_tgl: function(dateString) {
                      var date = new Date(dateString);
                      var getBulan = date.getMonth() + 1; var bulan = '';
                      if (getBulan == '1') {bulan = 'Januari'} 
                      else if(getBulan == '2') {bulan = 'Februari'}
                      else if(getBulan == '3') {bulan = 'Maret'}
                      else if(getBulan == '4') {bulan = 'April'}
                      else if(getBulan == '5') {bulan = 'Mei'}
                      else if(getBulan == '6') {bulan = 'Juni'}
                      else if(getBulan == '7') {bulan = 'Juli'}
                      else if(getBulan == '8') {bulan = 'Agustus'}
                      else if(getBulan == '9') {bulan = 'September'}
                      else if(getBulan == '10') {bulan = 'Oktober'}
                      else if(getBulan == '11') {bulan = 'November'}
                      else if(getBulan == '12') {bulan = 'Desember'}
  
  
  
                      return date.getDate() + " " + bulan + " " + date.getFullYear();
                      // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
                  }
  
  
      // ====================================== PAGINATE ====================================
  
  
  
  
  
  
  
    },
  
    mounted () {
      this.getView();
      this.date();
    },
  }
  